<!--
  <GoBackButton :to="{ name: 'Search' }" default="/sok/bostad"/>
-->
<template>
  <a class="btn btn-primary" @click.prevent="goBack()" :href="href">
    <slot>Tillbaka</slot>
  </a>
</template>
<script>
export default {
  props: {
    to: {
      type: Object,
      required: true,
    },
    default: {
      type: String,
      required: true,
    },
  },
  data() {
    // visas när man hovrar men gör egentligen inget.
    return {
      href: this.default,
    };
  },

  methods: {
    // Leta på :to i historiken, finns inte den, gå bara till default.
    goBack() {
      let matchingIndex = [...this.$router.stack].reverse().findIndex((entry) => {
        return entry.name === this.to.name;
      });

      if (matchingIndex === -1) {
        return this.$router.push(this.default);
      } else {
        // indexet i arrayen, reversat och minus tjohej
        let goTo =
          (this.$router.stack.length - (this.$router.stack.length - matchingIndex)) * -1 - 1;

        return this.$router.go(goTo);
      }
    },
  },
};
</script>
